// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SystemStatus_systemStatusWrap__f7eVn {
  grid-area: systemStatus;
}
.SystemStatus_systemStatusWrap__f7eVn .SystemStatus_systemStatus__3XcJL {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--feedbacksIndex);
  display: flex;
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: var(--background-color-1);
  padding: 0.5em;
  background: var(--foreground-color-1);
}
.SystemStatus_systemStatusWrap__f7eVn .SystemStatus_systemStatus__3XcJL > * + * {
  margin-left: 1em;
}
.SystemStatus_systemStatusWrap__f7eVn .SystemStatus_systemStatus__3XcJL.SystemStatus_danger__xaafk {
  background: var(--danger);
}
.SystemStatus_systemStatusWrap__f7eVn .SystemStatus_systemStatus__3XcJL.SystemStatus_success__LT8If {
  background: var(--success);
}`, "",{"version":3,"sources":["webpack://./src/views/Template/components/SystemStatus/SystemStatus.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;AAAE;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,cAAA;EACA,qCAAA;AAEJ;AADI;EACE,gBAAA;AAGN;AADI;EACE,yBAAA;AAGN;AADI;EACE,0BAAA;AAGN","sourcesContent":[".systemStatusWrap {\n  grid-area: systemStatus;\n  .systemStatus {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: var(--feedbacksIndex);\n    display: flex;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    color: var(--background-color-1);\n    padding: 0.5em;\n    background: var(--foreground-color-1);\n    > * + * {\n      margin-left: 1em;\n    }\n    &.danger {\n      background: var(--danger);\n    }\n    &.success {\n      background: var(--success);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"systemStatusWrap": `SystemStatus_systemStatusWrap__f7eVn`,
	"systemStatus": `SystemStatus_systemStatus__3XcJL`,
	"danger": `SystemStatus_danger__xaafk`,
	"success": `SystemStatus_success__LT8If`
};
export default ___CSS_LOADER_EXPORT___;
